.pageContent {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 15px;
  max-height: 100%;
  height: 100%;
}
.buttonRow {
  display: flex;
  gap: 8px;
}
.packingGroups {
  background: var(--static-background-strong);
  border-radius: 12px;
  border: 1px solid var(--static-divider-standard);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-top: 8px;
}
.shipmentRow {
  display: flex;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid var(--static-divider-standard);
  white-space: nowrap;
  gap: 8px;
  overflow: hidden;
  min-height: fit-content;
  flex-shrink: 0;
}
.shipmentOption {
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;
}
.selectedShipmentOption {
  background: var(--sentiment-background-positive);
}
